/**
 * Created by daniel on 23/04/17.
 */

import * as actions from "./actions";
import {CONTENT_DEFINITIONS} from "./initialConfig/itemDefinitions";
import {COLORS, CONTENT_DEFINITION_CATEGORIES} from "../../constants";

function contentDefinitions(stateContentDefinitions, action) {
  debugger;
  switch (action.type) {
    case actions.CONFIG_SET_CONTENT_DEFINITIONS:
      return action.contentDefinitions;
    case actions.CONFIG_RESET_CONTENT_DEFINITIONS:
      return CONTENT_DEFINITIONS;
    default:
      return stateContentDefinitions;
  }
}


export function config(state = {
  contentDefinitions: CONTENT_DEFINITIONS,
  contentDefinitionCategories: CONTENT_DEFINITION_CATEGORIES,
  colors: COLORS
}, action) {
  switch (action.type) {
    case actions.CONFIG_SET_CONTENT_DEFINITIONS:
    case actions.CONFIG_RESET_CONTENT_DEFINITIONS:
      return {...state, contentDefinitions: contentDefinitions(state.contentDefinitions, action)};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/Editor/state/config/reducers.js